'use strict';

const TouchCarousel = (($) => {

    const NAME = 'touchCarousel';
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {}

    class TouchCarousel {

        // totalWidth = 0;

        static get Default() {
            return Default
        }

        constructor($element, config) {
            this._config = $.extend({}, Default, config);
            this.$element = $element;

            this.isMoving = true;
            this.intervalId;
            this.isOpen = false;

            this.containerWidth = 0;
            this.totalWidth = 0;
            this.position = 0;

            this.increment = -1;

            this.init();
            this.addEventListeners();

            var _ = this;
        }

        init() {
            // console.log('touch carousel');

            this.containerWidth = this.$element.width();
            var totalWidth = 0;

            this.$element.find('li').each(function (index) {
                console.log($(this).width());
                totalWidth += parseInt($(this).width(), 10);
                // console.log(totalWidth);
            });

            this.totalWidth = totalWidth + 10;

            this.setStyle();
            this.startAutoRun();
        }

        reinit() {

        }

        addEventListeners() {
            var _self = this;

            $( window ).resize(function() {
                _self.stopAutoRun();
                _self.position = 0;
                _self.init();
            });

            this.$element.on('mousedown, touchstart', function (e) {
                _self.handleMouseDown()
            });

            this.$element.on('mouseup, touchend', function (e) {
                _self.handleMouseUp()
            });

            this.$element.find('ul').draggable({
                revert: true,
                revertDuration: 100,
                axis: 'x',
                drag: function (e, ui) {
                    // console.log(ui.position.left);

                    _self.position = ui.position.left;
                    _self.setStyle();

                    // y2 = ui.position.top;
                    // x2 = ui.position.left;
                    // if(x2>100){alert("greater than 100px");}
                    // if(x2<-100){alert("Lesser than -100px");}

                },
                start: function (e, ui) {
                    _self.startPositionLeft = ui.position.left;
                    _self.increment = -1;
                    // y1 = ui.position.top;
                    // x1 = ui.position.left;

                },
                stop: function (e, ui) {
                    // console.log('drag stop');
                    _self.increment = -1;
                    _self.startAutoRun();
                }
            });
        }

        handleMouseDown(e) {
            // console.log('mouse down');
            if (this.isMoving) {
                this.stopAutoRun();
            }
        }

        handleMouseUp(e) {
            // console.log('mouse up');
            if (!this.isMoving) {
                // this.startAutoRun();
            }
        }

        setStyle() {
            // console.log(this.position + ' ' + this.totalWidth);
            if (this.position > 0) {
                this.position = 0;
            }

            if (this.position < (this.containerWidth - this.totalWidth)) {
                this.position = this.containerWidth - this.totalWidth;
            }

            var styleWidth = 'width: ' + this.totalWidth + 'px; ';
            var styleTrans = 'transform-origin: 0px 0px; transform: translate3d(' + this.position + 'px, 0px, 0px); transition-property: none; ';

            // console.log(styleWidth + styleTrans);

            this.$element.find('ul').attr('style', styleWidth + styleTrans);
        }

        startAutoRun() {
            clearInterval(this.intervalId);
            this.intervalId = setInterval($.proxy(this._move, this), 20);
            this.isMoving = true;
        }

        stopAutoRun() {
            clearInterval(this.intervalId);
            this.isMoving = false;
        }

        _move() {
            this.position += this.increment;

            if (this.position < (this.containerWidth - this.totalWidth)) {
                this.increment = 5;
            }

            if (this.position > 0) {
                this.increment = -1;
            }

            this.setStyle();
            // console.log('move');
        }

        // getParentFigure() {
        //     return this.$element.parents('figure');
        // }

        static _jQueryInterface(config) {
            config = config || {};
            return this.each(() => {
                let $this = $(this);
                let _config = $.extend(
                    {},
                    TouchCarousel.Default,
                    $this.data(),
                    typeof config === 'object' && config
                );

                new TouchCarousel(this, _config)
            })
        }
    }

    $.fn[NAME] = TouchCarousel._jQueryInterface;
    $.fn[NAME].Constructor = TouchCarousel;
    $.fn[NAME].noConflict = () => {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return TouchCarousel._jQueryInterface
    };

    return TouchCarousel;

})(jQuery);

export default TouchCarousel;